<iq-dialog-header
  header="Please search for a store"
  [showCloseButton]="false"
></iq-dialog-header>
<iq-form-field class="store-selector-search-filter" icon="search">
  <input
    type="text"
    placeholder="Quick search for stores"
    iqInput
    [(ngModel)]="searchTerm"
    (input)="onInput()"
  />
</iq-form-field>
<div
  *ngIf="searchStarted && this.singleSelectableStore.options.length === 0"
  class="not-found-text"
>
  <b>
    Stores<br/>
  </b>
  Oops! Your search has returned no results. Please try again.
</div>

<iq-single-selection-list
  *ngIf="singleSelectableStore"
  class="store-list"
  [singleSelectionItem]="singleSelectableStore"
  (validSelection)="onValidSelection($event)"
>

  <div class="iq-dialog-buttons">
    <button
      type="submit"
      class="button primary-1"
      [disabled]="this.singleSelectableStore.options.length === 0"
    >
      Save
    </button>
    <button
      *ngIf="singleSelectableStore.allowCancel"
      type="button"
      class="button secondary-4"
      (click)="onExit()"
    >
      Exit
    </button>
  </div>
</iq-single-selection-list>

